import { z } from "@hono/zod-openapi";
import { tmsEventKind } from "../base";
import { formSubmissionRefs } from "../subjects/formSubmission/refs";

/**
 * The driver filed the daily check call.
 */
export const dailyCheckCallV1 = tmsEventKind(
  { category: "checkIn", kind: "dailyCheckCall", version: 1 },
  {
    refs: formSubmissionRefs,
    facts: {
      trailerNumber: z.string().nullable(),
    },
  },
);

export const DailyCheckCallV1Schema = dailyCheckCallV1.schema;
export const DailyCheckCallV1FactsSchema = dailyCheckCallV1.facts;

export type DailyCheckCallV1 = z.infer<typeof DailyCheckCallV1Schema>;
export type DailyCheckCallV1Facts = z.infer<typeof DailyCheckCallV1FactsSchema>;

/** Every version of `dailyCheckCall`, keyed by version. What `catalog.ts` places under `checkIn`. */
export const dailyCheckCall = { 1: dailyCheckCallV1 } as const;
